module.exports = __webpack_public_path__ + "static/media/shuffle_neon.29eaadc2.wav";